// Levenshtein distance for fuzzy matching medication / rhythm names.
export function levenshtein(a, b) {
  if (a === b) return 0;
  if (!a.length) return b.length;
  if (!b.length) return a.length;
  const prev = new Array(b.length + 1);
  const curr = new Array(b.length + 1);
  for (let j = 0; j <= b.length; j++) prev[j] = j;
  for (let i = 1; i <= a.length; i++) {
    curr[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
    }
    for (let j = 0; j <= b.length; j++) prev[j] = curr[j];
  }
  return prev[b.length];
}

const norm = (s) => (s || "").toLowerCase().trim().replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ");

export function fuzzyMatch(guess, aliases, tolerance = "moderate") {
  const g = norm(guess);
  if (!g) return false;
  const allowed = tolerance === "strict" ? 0 : tolerance === "lenient" ? 3 : 2;
  for (const a of aliases) {
    const n = norm(a);
    if (!n) continue;
    if (n === g) return true;
    // Scale allowed by length (short words should allow fewer edits; abbreviations must be exact)
    const maxEdits = n.length <= 3 ? 0 : Math.min(allowed, Math.max(1, Math.floor(n.length / 4)));
    if (levenshtein(g, n) <= maxEdits) return true;
  }
  return false;
}
